import React from 'react';
import { useSpectatorStore } from '../../store/spectatorSlice';

export const DownedBanner = () => {
  const downed = useSpectatorStore((s) => s.downedSelf);
  if (!downed) {
    return null;
  }
  return (
    <div style={bannerStyle}>
      Vous êtes à terre — un allié avec une Graine de réveil peut vous ranimer.
    </div>
  );
};

const bannerStyle: React.CSSProperties = {
  position: 'fixed',
  bottom: 24,
  left: '50%',
  transform: 'translateX(-50%)',
  zIndex: 9000,
  padding: '8px 16px',
  background: 'rgba(40,10,12,0.92)',
  color: '#ffd9d9',
  borderRadius: 6,
  font: '14px sans-serif',
  pointerEvents: 'none',
};
